// @ts-nocheck
import React, { useState } from 'react'
import styles from './index.scss'
import { Picker } from 'antd-mobile'
import classnames from 'classnames'
import { RightOutline } from 'antd-mobile-icons'

interface IDpPickerProps {
  columns: any[]
  title?: string
  onChange?: Function
  disabled?: boolean
  customStyles?: React.CSSProperties
  placeholder?: string
}
const DpPicker: React.FC<IDpPickerProps> = (props) => {
  const [currentValue, updateCurrentValue] = useState(props?.value)
  const renderItem = (open, items) => {
    return (
      <div className={styles['dp-picker-desc']} onClick={() => !props?.disabled && open()}>
        <div
          className={
          classnames([styles['dp-picker-desc-body'], { [styles['dp-picker-desc-body--disabled']]: props?.disabled } ])
        }
      >
          {items
            ?.map((_) => _?.label)
            ?.filter((_) => _)
            ?.join(',') || (
            <span className={styles['dp-picker-placeholder']}>{props?.placeholder || lang['请选择']}</span>
          )}
        </div>
        {!props?.disabled && <RightOutline className={styles['dp-picker-arrows']} />}
      </div>
    )
  }
  return (
    <Picker
      style={{
        '--item-font-size': '15px',
        '--item-height': '58px',
        '--z-index': '999',
        ...props?.customStyles,
        marginTop: 0
      }}
      {...props}
      value={props?.value ? (typeof props?.value === 'string' ? props?.value?.split?.(',') : props?.value ) : undefined}
      columns={props?.columns || []}
      onConfirm={() => props?.onChange?.(currentValue)}
      onSelect={(val) => updateCurrentValue(val)}
    >
      {(items, { open }) => renderItem(open, items)}
    </Picker>
  )
}

export default DpPicker
